import { InfoIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { CloseButton } from '@rsos/components/capstone/base';
import { BannerWrapper, IconWrapper } from './TextFrom911Banner.styles';

/**
 * Component that renders when an outbound SMS conversation transitions to a 911
 * call
 * @param {Function} onDismiss - Function to handle dismissing this banner
 */
const DidCallBanner = ({ onDismiss = () => {} }) => {
  return (
    <BannerWrapper horizontal justify="space-between">
      <Box horizontal>
        <IconWrapper>
          <InfoIcon height="16px" width="16px" />
        </IconWrapper>
        <Text color="background" ml="12px" size="normal">
          This conversation started as a Text-from-911.
        </Text>
      </Box>
      <CloseButton color="background" onClose={onDismiss} />
    </BannerWrapper>
  );
};

export default DidCallBanner;
